// ============================================================================
// MOCK DATA FOR FINANCE MODULE
// ============================================================================

export const revenueData = [
  { day: '1 Jan', current: 4200, previous: 3800 },
  { day: '4 Jan', current: 5800, previous: 5200 },
  { day: '7 Jan', current: 7200, previous: 6100 },
  { day: '10 Jan', current: 6800, previous: 7500 },
  { day: '13 Jan', current: 9200, previous: 8200 },
  { day: '16 Jan', current: 8400, previous: 7800 },
  { day: '19 Jan', current: 11200, previous: 9200 },
  { day: '22 Jan', current: 9800, previous: 10500 },
  { day: '25 Jan', current: 12400, previous: 11200, projected: 12400 },
  { day: '28 Jan', current: null, previous: null, projected: 14200 },
  { day: '31 Jan', current: null, previous: null, projected: 15800 },
];

// DEPRECATED: Staff data is now fetched from API via hairdresserService.staffListV2()
// These exports are kept for backwards compatibility but should not be used
export const staffMembers = [];

// DEPRECATED: Staff data is now fetched from API via hairdresserService.staffListV2()
// These exports are kept for backwards compatibility but should not be used
export const staffList = [];

export const topClients = [
  { name: 'Olivia Brown', email: 'olivia@email.com', spend: 1240 },
  { name: 'Sarah Johnson', email: 'sarah.j@email.com', spend: 980 },
  { name: 'Emma Williams', email: 'emma.w@email.com', spend: 756 },
  { name: 'Charlotte Davis', email: 'charlotte@email.com', spend: 645 },
];

export const newClients = [
  { name: 'Mia Taylor', source: 'Instagram', date: '24 Jan' },
  { name: 'Lily Anderson', source: 'Google', date: '23 Jan' },
  { name: 'Grace Thomas', source: 'Referral', date: '22 Jan' },
  { name: 'Ava Martinez', source: 'Walk-in', date: '21 Jan' },
];

// Chart data labels
export const chartLabels = {
  daily: ['1 Jan', '4 Jan', '8 Jan', '12 Jan', '16 Jan', '20 Jan', '24 Jan', '27 Jan'],
  weekly: ['W1', 'W2', 'W3', 'W4']
};

// Tips data
export const tipsData = [
  { name: 'Katherine Balza', amount: 124 },
  { name: 'Sarah Mitchell', amount: 98 },
  { name: 'Joel Peters', amount: 72 },
  { name: 'Emma Wilson', amount: 28 },
  { name: 'Benjamin Fisher', amount: 12 },
  { name: 'Charlie Marjot', amount: 8 },
];

// Initial commission data
export const initialCommissionData = [
  { name: 'Katherine Balza', owed: 180.00, paid: 120.00 },
  { name: 'Sarah Mitchell', owed: 320.00, paid: 320.00 },
  { name: 'Joel Peters', owed: 248.00, paid: 48.00 },
  { name: 'Emma Wilson', owed: 150.00, paid: 100.00 },
  { name: 'Benjamin Fisher', owed: 50.00, paid: 40.00 },
  { name: 'Charlie Marjot', owed: 50.00, paid: 50.00 },
  { name: 'Rachel Green', owed: 95.00, paid: 0.00 },
  { name: 'Tom Bradley', owed: 120.00, paid: 80.00 },
].map(s => ({ ...s, outstanding: s.owed - s.paid }));

// Payment segments for breakdown
export const paymentSegments = [
  { percent: 51, color: '#007EA0', label: 'Card' },
  { percent: 25, color: '#3b82f6', label: 'Cash' },
  { percent: 15, color: '#14b8a6', label: 'Online' },
  { percent: 6, color: '#f59e0b', label: 'Gift Card' },
  { percent: 3, color: '#ef4444', label: 'Other' },
];

// Sample transactions data
export const sampleTransactions = [
  {
    id: 'TXN-001',
    date: '28 Jan 2026',
    time: '14:32',
    client: 'Olivia Brown',
    clientEmail: 'olivia@email.com',
    staff: 'Katherine Balza',
    type: 'Service',
    services: ['Balayage', 'Cut & Blow Dry'],
    products: [],
    amount: 185.00,
    tip: 15.00,
    paymentMethod: 'Card',
    status: 'completed'
  },
  {
    id: 'TXN-002',
    date: '28 Jan 2026',
    time: '13:15',
    client: 'Sarah Johnson',
    clientEmail: 'sarah.j@email.com',
    staff: 'Joel Peters',
    type: 'Service + Product',
    services: ['Gents Cut'],
    products: ['Styling Paste'],
    amount: 42.00,
    tip: 5.00,
    paymentMethod: 'Cash',
    status: 'completed'
  },
  {
    id: 'TXN-003',
    date: '28 Jan 2026',
    time: '11:45',
    client: 'Emma Williams',
    clientEmail: 'emma.w@email.com',
    staff: 'Sarah Mitchell',
    type: 'Service',
    services: ['Full Head Colour', 'Treatment'],
    products: [],
    amount: 220.00,
    tip: 20.00,
    paymentMethod: 'Card',
    status: 'completed'
  },
  {
    id: 'TXN-004',
    date: '27 Jan 2026',
    time: '16:20',
    client: 'Charlotte Davis',
    clientEmail: 'charlotte@email.com',
    staff: 'Katherine Balza',
    type: 'Product',
    services: [],
    products: ['Shampoo', 'Conditioner', 'Hair Oil'],
    amount: 68.00,
    tip: 0,
    paymentMethod: 'Card',
    status: 'completed'
  },
  {
    id: 'TXN-005',
    date: '27 Jan 2026',
    time: '15:00',
    client: 'Mia Taylor',
    clientEmail: 'mia.t@email.com',
    staff: 'Emma Wilson',
    type: 'Service',
    services: ['Cut & Blow Dry'],
    products: [],
    amount: 55.00,
    tip: 8.00,
    paymentMethod: 'Online',
    status: 'completed'
  },
  {
    id: 'TXN-006',
    date: '27 Jan 2026',
    time: '12:30',
    client: 'Lily Anderson',
    clientEmail: 'lily.a@email.com',
    staff: 'Benjamin Fisher',
    type: 'Commission',
    services: [],
    products: [],
    amount: -45.00,
    tip: 0,
    paymentMethod: 'Bank Transfer',
    status: 'completed'
  },
];

// Sample cash up sessions
export const sampleCashUpSessions = [
  { 
    id: 1, 
    date: 'Wednesday, 28th January 2026',
    dateShort: '28.01.2026',
    status: 'incomplete',
    cashedUpBy: 'Phoebe King',
    notes: null,
    lastEdit: '00:05 on 28.01.26',
    cashExpected: 245.00,
    cardExpected: 1850.00,
    otherExpected: 120.00,
  },
  { 
    id: 2, 
    date: 'Thursday, 22nd January 2026',
    dateShort: '22.01.2026',
    status: 'incomplete',
    cashedUpBy: 'Phoebe King',
    notes: null,
    lastEdit: '16:11 on 22.01.26',
    cashExpected: 180.00,
    cardExpected: 2100.00,
    otherExpected: 85.00,
  },
  { 
    id: 3, 
    date: 'Thursday, 15th January 2026',
    dateShort: '15.01.2026',
    status: 'complete',
    cashedUpBy: 'Phoebe King',
    notes: 'All balanced',
    lastEdit: '11:24 on 15.01.26',
    cashExpected: 320.00,
    cardExpected: 1920.00,
    otherExpected: 45.00,
    cashActual: 320.00,
    cardActual: 1920.00,
    otherActual: 45.00,
  },
  { 
    id: 4, 
    date: 'Friday, 9th January 2026',
    dateShort: '09.01.2026',
    status: 'complete',
    cashedUpBy: 'Phoebe King',
    notes: 'Short £5 cash - petty cash used',
    lastEdit: '13:54 on 09.01.26',
    cashExpected: 275.00,
    cardExpected: 1650.00,
    otherExpected: 90.00,
    cashActual: 270.00,
    cardActual: 1650.00,
    otherActual: 90.00,
  },
];

// Report categories
export const reportCategories = [
  { id: 'all', label: 'All Reports' },
  { id: 'financial', label: 'Financial' },
  { id: 'staff', label: 'Staff' },
  { id: 'clients', label: 'Clients' },
  { id: 'products', label: 'Products' },
];

// Report types with categories
export const reportTypes = [
  // Financial Reports
  {
    id: 'revenue-summary',
    category: 'financial',
    name: 'Revenue Summary',
    description: 'Complete breakdown of revenue by service, product, and payment method',
    icon: 'chart',
    popular: true
  },
  // {
  //   id: 'end-of-day',
  //   category: 'financial',
  //   name: 'End of Day Takings',
  //   description: 'Daily cash up report with payment method breakdown',
  //   icon: 'cash',
  //   popular: true
  // },
  {
    id: 'payment-methods',
    category: 'financial',
    name: 'Sales by Payment Method',
    description: 'Revenue split by cash, card, voucher, etc.',
    icon: 'card'
  },
  // Staff Reports
  {
    id: 'sales-by-staff',
    category: 'staff',
    name: 'Sales by Staff',
    description: 'Individual revenue and service breakdown per team member',
    icon: 'users',
    popular: true
  },
  {
    id: 'commission-payroll',
    category: 'staff',
    name: 'Commission Paid',
    description: 'Commission earned, paid, and outstanding by staff member',
    icon: 'calculator',
    popular: true
  },
  {
    id: 'tips-report',
    category: 'staff',
    name: 'Tips by Staff',
    description: 'Tips received per staff member for the period',
    icon: 'cash'
  },
  {
    id: 'holiday-report',
    category: 'staff',
    name: 'Holiday & Leave',
    description: 'Staff holidays and days off taken in the period',
    icon: 'sun'
  },
  {
    id: 'seat-utilisation',
    category: 'staff',
    name: 'Staff Utilisation',
    description: 'Booked time vs available hours per staff member, based on rotas',
    icon: 'chart',
    popular: true
  },
  // Client Reports
  {
    id: 'rebook-rate',
    category: 'clients',
    name: 'Rebook Rate',
    description: 'Percentage of appointments where the client rebooked within a chosen time window',
    icon: 'refresh',
    popular: true
  },
  {
    id: 'client-retention',
    category: 'clients',
    name: 'Client Retention',
    description: 'Percentage of clients who booked again within a chosen time window',
    icon: 'heart'
  },
  {
    id: 'new-vs-returning',
    category: 'clients',
    name: 'New vs Returning Clients',
    description: 'Breakdown of first-time and repeat clients with details',
    icon: 'users'
  },
  // Product Reports
  {
    id: 'product-sales',
    category: 'products',
    name: 'Product Sales',
    description: 'Retail performance by product and category',
    icon: 'box',
    popular: true
  },
  {
    id: 'inventory-report',
    category: 'products',
    name: 'Inventory Report',
    description: 'Current stock levels, valuation, and last stocktake summary',
    icon: 'box'
  },
  {
    id: 'gift-vouchers',
    category: 'products',
    name: 'Gift Vouchers',
    description: 'Voucher sales and redemptions for the period',
    icon: 'gift'
  },
];

// Date preset labels
export const datePresetLabels = {
  'today': 'Today',
  'yesterday': 'Yesterday',
  'last7': 'Last 7 days',
  'last4weeks': 'Last 4 weeks',
  'last6months': 'Last 6 months',
  'last12months': 'Last 12 months',
  'wtd': 'Week to date',
  'mtd': 'Month to date',
  'qtd': 'Quarter to date',
  'ytd': 'Year to date',
  'all': 'All time',
};

// Helper function to get date preset label
export const getDatePresetLabel = (presetId) => {
  return datePresetLabels[presetId] || 'Month to date';
};

// Generate chart data based on granularity
export const generateChartData = (granularity, baseValues, labels) => {
  if (granularity === 'daily') {
    return labels.daily.map((label, i) => ({
      label,
      value: baseValues[i % baseValues.length] + Math.random() * 5
    }));
  } else {
    return labels.weekly.map((label, i) => ({
      label,
      value: baseValues[i % baseValues.length] * 7 + Math.random() * 20
    }));
  }
};
